import { createAsyncThunk } from "@reduxjs/toolkit";
import { promiseFetchDataAuth } from 'crk-front-lib';
import { makeKeySubValue } from 'crk-lib-tool/tools/json-util';
import { assignDotKeyValue } from 'crk-lib-tool/tools/data-util';

const APIPATH = '/api/v2/admin';

export const queryPayment = createAsyncThunk('payments/querySlip', async (cond, thunkAPI) => {
  const url = `${APIPATH}/payslips`;
  let _qry = '';

  if(cond.keyword && cond.keyword !== '') {
    _qry += ( _qry === '' ? '' : '&' ) + `keyword=` + encodeURIComponent(cond.keyword);
  }

  if(cond.status && cond.status !== '') {
    _qry += ( _qry === '' ? '' : '&' ) + `pay_status=${cond.status}`;
  }

  const result = await promiseFetchDataAuth(url + (_qry === '' ? '' : `?${_qry}`));
  for (const row of result) {
    assignDotKeyValue(row, ['app.app_name', 'app.app_desc', 'member.fullname', 'member.email']);
  }

  return result;
})

export const readPayment = createAsyncThunk('payments/readSlip', async (pay_id, thunkAPI) => {
  const url = `${APIPATH}/payslips/${pay_id}`;
  const result = await promiseFetchDataAuth(url);

  makeKeySubValue(result);

  return result;
})

export const changeStatus = createAsyncThunk('pays/changeStatus', async ({pay_id, status}, thunkAPI) => {
  const url = `${APIPATH}/payslips/${pay_id}`;
  const result = await promiseFetchDataAuth(url, 'PATCH', { status });  

  return result;
})
